module.exports = __webpack_public_path__ + "static/media/movies.e5267257.svg";